var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCarouselDot1 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "6px",
    viewBox: "0 0 42 6",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Homeowner-mobile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Onboarding-Step-2",
    transform: "translate(-167.000000, -715.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(167.000000, 715.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,0 C1.346,0 0,1.346 0,3 C0,4.654 1.346,6 3,6 C4.654,6 6,4.654 6,3 C6,1.346 4.654,0 3,0",
    id: "Fill-1039",
    className: "premiumIcon",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,0 C13.346,0 12,1.346 12,3 C12,4.654 13.346,6 15,6 C16.654,6 18,4.654 18,3 C18,1.346 16.654,0 15,0",
    id: "Fill-1040",
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27,0 C25.346,0 24,1.346 24,3 C24,4.654 25.346,6 27,6 C28.654,6 30,4.654 30,3 C30,1.346 28.654,0 27,0",
    id: "Fill-1041",
    fill: "#E9E9E9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(36.000000, 0.000000)",
    fill: "#E9E9E9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,0 C1.346,0 0,1.346 0,3 C0,4.654 1.346,6 3,6 C4.654,6 6,4.654 6,3 C6,1.346 4.654,0 3,0",
    id: "Fill-1039"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCarouselDot1);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/carouselDot1.162331feb71afe5f60e7a8a6e39843d9.svg";